import { useState, useEffect, useCallback, useRef } from 'react';
import useSmartPolling from './useSmartPolling';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const POLL_INTERVAL = 60000; // 60 seconds

export function useShiftAlarms() {
  const [alarms, setAlarms] = useState([]);
  const [currentTime, setCurrentTime] = useState('');
  const [hasAlarms, setHasAlarms] = useState(false);
  const notifiedRef = useRef(new Set());

  const fetchAlarms = useCallback(async () => {
    const token = localStorage.getItem('admin_token');
    if (!token) return;

    try {
      const res = await fetch(`${API_URL}/api/timeclock/alarms`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setAlarms(data.alarms || []);
        setCurrentTime(data.current_time || '');
        setHasAlarms(data.has_alarms || false);
        return data.alarms || [];
      }
    } catch (e) {
      console.error('Error fetching alarms:', e);
    }
    return [];
  }, []);

  useEffect(() => {
    fetchAlarms();
  }, [fetchAlarms]);

  useSmartPolling(fetchAlarms, POLL_INTERVAL);

  // Reset notified set every 10 minutes to allow re-notification
  useEffect(() => {
    const reset = setInterval(() => {
      notifiedRef.current.clear();
    }, 600000);
    return () => clearInterval(reset);
  }, []);

  const getUnnotified = useCallback(() => {
    const newAlarms = alarms.filter(a => {
      const key = `${a.employee_id}-${a.type}-${a.scheduled_time}`;
      return !notifiedRef.current.has(key);
    });
    // Mark as notified
    newAlarms.forEach(a => {
      const key = `${a.employee_id}-${a.type}-${a.scheduled_time}`;
      notifiedRef.current.add(key);
    });
    return newAlarms;
  }, [alarms]);

  return { alarms, currentTime, hasAlarms, fetchAlarms, getUnnotified };
}
